<template>
  <span v-if="value!=null">{{Number(value).toLocaleString()}} {{unit}}</span>
  <span v-else> --- {{unit}}</span>
</template>
<script>
export default {
  props: {
    value: {
      required: true,
    },
    unit: {
      type: String,
      required: false,
    }
  },
  mounted: async function () {
  },
  methods: {
  }
}
</script>
